export function projectIdToCompanyId(projectId, companies) {
  for (const companyId in companies) {
    if (companies[companyId].projects.includes(projectId)) {
      return companyId;
    }
  }
  return null;
}
